export default __webpack_public_path__ + "static/deutsche-bank-partnerschaft-5119c6bee4bdacc7cc1f6bf6dafdd13f.svg";